module.exports = __webpack_public_path__ + "70e3477eb7edc1abc0fd2703aec1760f.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/logos/JabJab-Cuisine-logo.jpg
// module id = 789
// module chunks = 0